/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import * as types from './types';

export const state = {
  list: [],
  load: false,
  dialog: false,
  successStatus: false,
  errorStatus: false,
  errorMessage: '',
  sendReceiptResponse: {},
  id: '',
  loadFile: false,
  fileConverted: '',
  
  // Filtros
  filtersInitialDate: moment().startOf('month').format('YYYY-MM-DD'),
  filtersFinalDate: moment().endOf('month').format('YYYY-MM-DD'),
  filtersStatus: '',
  filtersReason: '',
  filtersAmount: '',
  filtersOrdination: '',
  showFilters: false,
  currentPage: 1,
  limit: 25,
};

export const mutations = {
  [types.LIST](state, list) {
    state.list = list;
  },
  [types.LOAD](state, load) {
    state.load = load;
  },
  [types.DIALOG](state, dialog) {
    state.dialog = dialog;
  },
  [types.SUCCESS_STATUS](state, successStatus) {
    state.successStatus = successStatus;
  },
  [types.ERROR_STATUS](state, errorStatus) {
    state.errorStatus = errorStatus;
  },
  [types.ERROR_MESSAGE](state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  [types.SEND_RECEIPT_RESPONSE](state, sendReceiptResponse) {
    state.sendReceiptResponse = sendReceiptResponse;
  },
  [types.ID](state, id) {
    state.id = id;
  },
  [types.LOAD_FILE](state, loadFile) {
    state.loadFile = loadFile;
  },
  [types.FILE_CONVERTED](state, fileConverted) {
    state.fileConverted = fileConverted;
  },
  
  // Filtros
  [types.FILTERS_INITIAL_DATE](state, date) {
    state.filtersInitialDate = date;
  },
  [types.FILTERS_FINAL_DATE](state, date) {
    state.filtersFinalDate = date;
  },
  [types.FILTERS_STATUS](state, status) {
    state.filtersStatus = status;
  },
  [types.FILTERS_REASON](state, reason) {
    state.filtersReason = reason;
  },
  [types.FILTERS_AMOUNT](state, amount) {
    state.filtersAmount = amount;
  },
  [types.FILTERS_ORDINATION](state, ordination) {
    state.filtersOrdination = ordination;
  },
  [types.SHOW_FILTERS](state, show) {
    state.showFilters = show;
  },
  [types.CURRENT_PAGE](state, page) {
    state.currentPage = page;
  },
  [types.LIMIT](state, limit) {
    state.limit = limit;
  },
};
